import React, {ReactElement} from 'react';
import {LogoCobrand, LogoLibertyMutualHoriz} from '@lmig/lmds-react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import styles from './logo-component.module.scss';


const LogoComponent = (): ReactElement => {
  const flags = useFlags();

  return flags?.brandingLibertyOnlyV1 ? (
    <LogoLibertyMutualHoriz className={styles.libertyLogo} />
  ) : (
    <LogoCobrand className={styles.cobrandLogo} />
  );
};

export default LogoComponent;
